// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__Z_5jP","hide":"Loading_hide__Z7Rim"};